export default __webpack_public_path__ + "static/media/avatar-ligo-white.9ff13eac.svg";